module.exports = __webpack_public_path__ + "assets/img/88_319_1.d36daa02.jpg";